import { Component, ErrorInfo, ReactNode } from "react"

import * as Sentry from "@sentry/react"

import styles from "./RootErrorBoundary.module.scss"

import { sendErrorEvent } from "@/lib/ts/errorEvent"

type Props = {
	children: ReactNode
}

type State = {
	hasError: boolean
}

// render 中の throw を拾う唯一の場所 (イベントハンドラ・非同期の throw はここに来ない。
// それらは errorEvent.ts の setupGlobalErrorHandlers が拾う)。
// これが無いと render 中に throw した時にツリー全体がアンマウントされ白画面になる
export class RootErrorBoundary extends Component<Props, State> {
	constructor(props: Props) {
		super(props)
		this.state = { hasError: false }
	}

	static getDerivedStateFromError(): State {
		return { hasError: true }
	}

	componentDidCatch(error: Error, errorInfo: ErrorInfo) {
		sendErrorEvent("error_boundary", error, {
			component_stack: (errorInfo.componentStack ?? "").slice(0, 2000),
		})
		Sentry.captureException(error)
	}

	render() {
		if (this.state.hasError) {
			return (
				<div className={styles.container}>
					<h1 className={styles.title}>エラーが発生しました</h1>
					<p className={styles.description}>
						お手数ですが、ページを再読み込みしてください。
						<br />
						解消しない場合は、時間をおいて再度お試しください。
					</p>
					<button
						className={styles.reloadButton}
						onClick={() => window.location.reload()}
					>
						再読み込み
					</button>
				</div>
			)
		}

		return this.props.children
	}
}
